import React, { useState, useEffect, useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  changeDateFormat,
  changeDateToYearMonthDay,
} from "../../../Utils/utils";
import CalendarIcon from "assets/medication/calender.svg";
import { FaTimesCircle } from "react-icons/fa";
import enGB from "date-fns/locale/en-GB";

enGB.options = { ...enGB.options, weekStartsOn: 1 };
registerLocale("en-GB", enGB);

const DateRangeWithRegister = (props) => {
 
  const {
    isSingleDate = false,
    singleSelectedDate,
    handleCancel,
    handleChange,
    currentDate,
    fromDate,
    selected,
    toDate,
    isDisabled = false,
    showCalendar = false,
    isClearable = true,
    cssClass = "",
    maxDate,
    setSelectedFromDate = null,
    setIsDisableSearch,
    showCalendarIcon = false,
    placeholder,
    minDate,
  
    field = null,
    fieldState = null,
  } = props;

  const datePickerRef = useRef(null);


  const [dateRange, setDateRange] = useState([null, null]);

  useEffect(() => {
    setDateRange([
      fromDate ? new Date(fromDate) : null,
      toDate ? new Date(toDate) : null,
    ]);
  }, [fromDate, toDate]);



  const valueToUse = isSingleDate
    ? field?.value || singleSelectedDate || null
    : dateRange;

  const onChangeToUse = (val) => {
    if (field && field.onChange) {
      
      if (isSingleDate) {
        field.onChange(changeDateToYearMonthDay(val));
      } else if (val && val.length === 2) {
     
        field.onChange({
          fromDate: changeDateToYearMonthDay(val[0]),
          toDate: changeDateToYearMonthDay(val[1]),
        });
      } else {
        field.onChange(val);
      }
    } else if (handleChange) {
    
      if (isSingleDate) {
        handleChange(changeDateToYearMonthDay(val));
      } else if (val && val.length === 2) {
        handleChange({
          fromDate: changeDateToYearMonthDay(val[0]),
          toDate: changeDateToYearMonthDay(val[1]),
        });
      } else {
        handleChange(val);
      }
    }
  };


  const onCancelToUse = () => {
    if (handleCancel) {
      handleCancel();
    } else if (field && field.onChange) {
    
      if (isSingleDate) {
        field.onChange(null);
      } else {
        field.onChange(null);
      }
    }
  };

  const [startDate, endDate] = dateRange;

  const handleClickIcon = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="relative">
      <input
        ref={ref}
        value={value}
        onClick={onClick}
        className={`did-floating-input capitalize ${cssClass}`}
        placeholder={placeholder ? placeholder : ""}
        disabled={isDisabled}
      />

      {isSingleDate ? (
        !value && (
          <img
            src={CalendarIcon}
            alt="no calendar"
            className="absolute right-2 top-2 w-5 h-5 cursor-pointer"
            onClick={handleClickIcon}
          />
        )
      ) : (
        !startDate && !endDate && (
          <img
            src={CalendarIcon}
            alt="no calendar"
            className="absolute right-2 top-2 w-5 h-5 cursor-pointer"
            onClick={handleClickIcon}
          />
        )
      )}
    </div>
  ));

  if (isSingleDate) {
    return (
      <div className="date-range-picker-field date-range-with-register relative w-full min-w-0">
        <DatePicker
        ref={datePickerRef}
        dateFormat={"dd/MM/yyyy"}
        disabled={isDisabled}
        selectsRange={false}
        wrapperClassName="w-full"
        className={`did-floating-input capitalize w-full ${cssClass}`}
        selected={valueToUse ? new Date(valueToUse) : null}
        onChange={(date) => {
          if (date) {
            onChangeToUse(date);
          } else {
            onCancelToUse();
          }
        }}
        isClearable={isDisabled ? false  : isClearable ? isClearable : true}
        placeholderText={"DD/MM/YYYY"}
        maxDate={maxDate}
        minDate={minDate}
        // customInput={showCalendarIcon ? <CustomInput /> : null}
        locale="en-GB"
      />
        {showCalendarIcon && !valueToUse && (
          <img
            src={CalendarIcon}
            alt="calendar"
            className="pointer-events-auto absolute right-3 top-1/2 z-[1] h-5 w-5 -translate-y-1/2 cursor-pointer"
            onClick={handleClickIcon}
          />
        )}
      </div>
      // <DatePicker
      //   ref={datePickerRef}
      //   dateFormat={"dd/MM/yyyy"}
      //   disabled={isDisabled}
      //   selectsRange={false}
      //   className={`did-floating-input capitalize ${cssClass}`}
      //   selected={valueToUse ? new Date(valueToUse) : null}
      //   onChange={(date) => {
      //     if (date) {
      //       onChangeToUse(date);
      //     } else {
      //       onCancelToUse();
      //     }
      //   }}
      //   isClearable={isDisabled ? false : isClearable}
      //   placeholderText={"DD/MM/YYYY"}
      //   maxDate={maxDate}
      //   minDate={minDate}
      //   customInput={showCalendarIcon ? <CustomInput /> : null}
      //   locale="en-GB"
      // />
    );
  }

  return (
    <div className="date-range-picker-field date-range-with-register relative w-full min-w-0">
    <DatePicker
      ref={datePickerRef}
      inline={showCalendar}
      dateFormat={"dd/MM/yyyy"}
      disabled={isDisabled}
      wrapperClassName="w-full"
      className="did-floating-input capitalize w-full"
      selectsRange={true}
      selected={selected}
      startDate={startDate}
      endDate={endDate}
      onChange={(selectedDates) => {
        if (setSelectedFromDate && selectedDates[0]) {
          setSelectedFromDate(selectedDates[0]);
        } else if (setSelectedFromDate && !selectedDates[0]) {
          setSelectedFromDate(null);
        }

        if (
          selectedDates &&
          selectedDates.length > 0 &&
          !selectedDates[0] &&
          !selectedDates[1]
        ) {
          onCancelToUse();
          setDateRange([null, null]);
        } else if (
          selectedDates &&
          selectedDates.length > 0 &&
          selectedDates[0] &&
          selectedDates[1]
        ) {
          setDateRange(selectedDates);
          if (setIsDisableSearch) {
            setIsDisableSearch(false);
          }
          onChangeToUse(selectedDates);
        } else {
          setDateRange(selectedDates);
          if (setIsDisableSearch) {
            setIsDisableSearch(true);
          }
        }
      }}
      isClearable={isClearable}
      placeholderText={"DD/MM/YYYY  to  DD/MM/YYYY "}
      maxDate={maxDate}
      locale="en-GB"
      customInput={showCalendarIcon ? <CustomInput /> : null}
      popperClassName={showCalendarIcon && "custom-datepicker"}
      openToDate={new Date()}
    />
    </div>
  );
};

export default DateRangeWithRegister;
